import { render, staticRenderFns } from "./LeftContent.vue?vue&type=template&id=386743ba&scoped=true"
import script from "./LeftContent.vue?vue&type=script&lang=js"
export * from "./LeftContent.vue?vue&type=script&lang=js"
import style0 from "./LeftContent.vue?vue&type=style&index=0&id=386743ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386743ba",
  null
  
)

export default component.exports